module.exports = __webpack_public_path__ + "img/61583E_252314_928972_342C1C-256px.6d8e2f7f.png";